/* AFORDA Dispatch: reflect selected Shopify radio option in the UI. */
(() => {
  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
    const picker = input.closest('fieldset.aforda-shipping-option');
    if (!picker) return;
    const display = picker.querySelector('[data-aforda-shipping-selected]');
    if (display) display.textContent = input.value;
  });
})();